import axios from "axios";
import { BusinessService } from "@/common/api.service";
import {
  GET_BUSINESS_LIST,
  UPDATE_BUSINESS_STATUS,
  DELETE_BUSINESS,
  GET_BUSINESS_OVERVIEW,
  GET_BUSINESS_TRANSACTIONS,
  GET_BUSINESS_TRANSACTION_DETAIL,
  EXPORT_BUSINESS_TRANSACTIONS,
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";
const state = {
  errors: null,
  business_list: {},
};

const getters = {
  business_list(state) {
    return state.business_list;
  },
};

const buildTransactionQuery = (params = {}) => {
  const query = new URLSearchParams();
  if (params.page != null) query.append("page", params.page);
  if (params.limit != null) query.append("limit", params.limit);
  if (params.sort) query.append("sort", params.sort);
  if (params.date_from && params.date_to) {
    query.append("date_from", params.date_from);
    query.append("date_to", params.date_to);
  }
  if (Array.isArray(params.transaction_status)) {
    params.transaction_status.forEach((s) =>
      query.append("transaction_status", s),
    );
  } else if (params.transaction_status) {
    query.append("transaction_status", params.transaction_status);
  }
  if (params.search) query.append("search", params.search);
  const qs = query.toString();
  return qs ? `?${qs}` : "";
};

const actions = {
  // Get Business List
  async [GET_BUSINESS_LIST](context, payload) {
    BusinessService.init();
    BusinessService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      BusinessService.get(`business/list${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update Business Status
  async [UPDATE_BUSINESS_STATUS](context, payload) {
    BusinessService.init();
    BusinessService.setHeader();
    return new Promise((resolve) => {
      BusinessService.put(`business/actions/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Delete Business
  async [DELETE_BUSINESS](context, payload) {
    BusinessService.init();
    BusinessService.setHeader();
    return new Promise((resolve) => {
      BusinessService.put(`business/actions/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Business Overview (profile + balances)
  async [GET_BUSINESS_OVERVIEW](context, businessid) {
    BusinessService.init();
    return new Promise((resolve) => {
      BusinessService.get(`business/${businessid}/overview`)
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },

  // Business Transactions list
  async [GET_BUSINESS_TRANSACTIONS](context, payload) {
    BusinessService.init();
    const { businessid, ...rest } = payload;
    const query = buildTransactionQuery(rest);
    return new Promise((resolve) => {
      BusinessService.get(`business/${businessid}/transactions${query}`)
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },

  // Business Transaction Detail
  async [GET_BUSINESS_TRANSACTION_DETAIL](context, payload) {
    BusinessService.init();
    const { businessid, transactionId } = payload;
    return new Promise((resolve) => {
      BusinessService.get(
        `business/${businessid}/transactions/${transactionId}`,
      )
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },

  // Export Transactions (CSV / PDF) — returns blob + filename
  async [EXPORT_BUSINESS_TRANSACTIONS](context, payload) {
    BusinessService.init();
    const { businessid, format, ...rest } = payload;
    const query = buildTransactionQuery(rest);
    const sep = query ? "&" : "?";
    // Pass a path relative to axios.defaults.baseURL (set by BusinessService.init()).
    // Don't prepend the baseURL manually — axios concatenates it itself, and
    // doing both produces "/api/v1/api/v1/..." for absolute baseURLs.
    const url = `business/${businessid}/transactions/export${query}${sep}format=${format}`;
    return axios.get(url, { responseType: "blob" }).then((response) => {
      const disposition = response.headers["content-disposition"] || "";
      const match = disposition.match(/filename="?([^";]+)"?/);
      const filename =
        (match && match[1]) ||
        `transactions-${businessid}-${Date.now()}.${format}`;
      return { blob: response.data, filename };
    });
  },
};
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
